import * as React from "react";

const GuideEmbed: React.FC<any> = (props) => {
  return <div style={{ width: "100%", height: "100%" }}>{props.children}</div>;
};

export default GuideEmbed;
